<template>
  <v-btn text @click="signOut">Sign Out</v-btn>
</template>

<script>
import Vue from 'vue';
import Component from 'vue-class-component';
import authentication from '@/services/Authentication';

@Component
export default class SignOut extends Vue {
  signOut() {
    authentication.unauthenticate();
    this.$emit('signedOut');
  }
}
</script>
